module.exports = __webpack_public_path__ + "assets/images/container_phase1.fcbcf12d944d51094ebe9e11db5b83ff.svg";